import { Component, OnInit, Output, EventEmitter, OnDestroy, ViewChild, ElementRef, Input, TemplateRef } from '@angular/core';
import { NgbModal, NgbDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray, FormControl } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { MentorshipService } from 'src/app/services/mentorship.service';
import { DatePipe } from '@angular/common';
import { MyAccountService } from 'src/app/services/my-account.service';
import { CourseService } from 'src/app/services/course.service';
import { CalendarService } from 'src/app/calendar-schedule/services/calendar.service';
import { UserRole } from 'src/app/shared/user-role';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { Roles } from 'src/app/auth/roles.enum';
import { AuthorizationService } from 'src/app/services/authorization.service';

@Component({
  selector: 'app-create-event',
  templateUrl: './create-event.component.html',
  styleUrls: ['./create-event.component.scss']
})
export class CreateEventComponent implements OnInit, OnDestroy {

  addEventModel: any = '';
  saveLoader: boolean = false;
  addEventForm!: FormGroup;
  eventId: string = '';
  submitEvent: boolean = false;
  formType: string = 'add';
  eventActionSub!: Subscription;
  typeChangeSubscription!: Subscription;
  get_zoom_account:any;
  zoom_accounts:any = [];
  selectedZoomAccount:string = null;
  formattedEventDate:string = null;
  selectedCouseId:string = null;
  coursesList:any = [];
  createEventStep1:boolean = true;
  createEventStep2:boolean = false;
  selectStudentErrorText:boolean = false;
  stepTosubmitEvent:boolean = false;
  isCheckedAll:boolean = false;
  isSearching:boolean = false;
  selectedLevelType:string = 'no_value';
  infoAlertMessage:string = 'No one has subscribe this course yet';
  searchStudentsQuery:string = '';
  selectStudentListOriginal:any = [];
  selectStudentList:any = [];
  selectedStudentList:any = [];
  getSubscribeStudentList:any = [];
  selectOptionLevel:any = [
    {
      name:'Course',
      type:'course',
      _id:1
    },
    {
      name:'Organization',
      type:'org',
      _id:2
    }
  ]

orgCourseList:any = [];
default_org:any = [];
accessible_org:any = [];
setTimeOutFun:any;
role: string = ''; 
allowedRoles:Roles[] = [Roles.TEACHER, Roles.MENTOR, Roles.ORG_ADMIN];   
public UserRole = new UserRole();
userId:string = '';
userFirstName:string = '';
userLastName:string = '';
userEmailID:string = '';
teamsList: string[] = [];
passionProjectId:string = '';
selectedStuentsArray:any = [];
formattedDate:any = null;
formattedDateStart:any = null;
formattedDateEnd:any = null;
selectedStudentsArray: any[] = [];
selectedTeams: any[] = [];

memberListId:any = [];
mentorListId:any = [];

dropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false
    };

@Input() projectTeams:any = [];
@Input() projectDetails:any;


@Output() eventStatus = new EventEmitter<any>();

  @ViewChild('createNewEvent', {static: false}) createNewEvent : ElementRef;

// selectedStudentsArray: any[] = [];
// selectedTeams: any[] = [];
  //FOR EDIT FORM
  selectedEvent: any = null;

  constructor(private activateRoute:ActivatedRoute, 
    private modal: NgbModal, private fb: FormBuilder, 
    private notificationService: NotificationService, 
    private calendarService: CalendarService, 
    private user_service:UserService, 
    private mentorshiptService:MentorshipService,
    private datePipe: DatePipe,
    private myAccountService:MyAccountService, 
    private courseService:CourseService, 
    private common: CommonService,
    public perm: AuthorizationService) { }

  ngOnInit() {
    this.role = this.UserRole.userRole;
    this.userId = localStorage.getItem('user_id');
    this.userFirstName = localStorage.getItem('first_name');
    this.userLastName = localStorage.getItem('last_name');
    this.userEmailID = localStorage.getItem('Email_ID');
    this.activateRoute.queryParams.subscribe(params => {
      this.passionProjectId = params.id;
    });

    this.initializeData(); 

    //FOR EDIT FORM
      if (!this.addEventForm) {
        console.error('Form not initialized');
        return;
      }

    this.eventActionSub = this.calendarService.getEventAction.subscribe((data) => {
      if(data.action == 'edit') {
        this.formType = 'edit';
        this.selectedEvent = data.selectedEvent;
        this.openEventModel();
        this.onTypeChangeChecks();
        this.setEditEventData();
      }
    });
   }

  onTypeChangeChecks(){
      if (this.typeChangeSubscription) {
        this.typeChangeSubscription.unsubscribe();
      }

        // add validation on Form Control on conditonal
    this.typeChangeSubscription =  this.addEventForm.get('led_by.type').valueChanges.subscribe((typeValue: string) => {
      const idControl = this.addEventForm.get('led_by.id');
      const nameControl = this.addEventForm.get('led_by.name');
      const emailControl = this.addEventForm.get('led_by.email');
      
      let pattern = /^[a-z](?:(?:[^-$<>()[\]\\.,;:\s@"]+(?:\.[^-$<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?:[a-zA-Z0-9]+\.)+[a-zA-Z]{2,}$/;
      if (typeValue === 'mentor_led') {
        idControl.setValidators([Validators.required]);
        emailControl.setValidators([Validators.required, Validators.pattern(pattern)]);
      } if (typeValue === 'guest_led') {
        emailControl.setValidators([Validators.required,  Validators.pattern(pattern)]);
      } else{
          idControl.clearValidators();
          emailControl.clearValidators();
      }

          idControl.updateValueAndValidity();
          emailControl.updateValueAndValidity();

       if (typeValue === 'mentor_led') {
          this.addEventForm.get('led_by.id').setValue(this.userId);
          this.addEventForm.get('led_by.name').setValue([this.userFirstName + this.userLastName]);
          this.addEventForm.get('led_by.email').setValue(this.userEmailID);
        } else{
        this.addEventForm.get('led_by.id').setValue('');
        this.addEventForm.get('led_by.name').setValue([]);
        this.addEventForm.get('led_by.email').setValue('');
      }
      // alert if there is not team created
      if (['team_led', 'mentor_led'].includes(typeValue)) {
         if(this.projectTeams.length === 0){
              this.notificationService.showNotification('info', `No team found. Please create a team to continue.`);
            return false;
          }
        } 

    });
  }

  // Reset selected teams and students when radio type changes
  onLedByTypeChange(val:any){
    this.selectedTeams = [];
    this.selectedStudentsArray = [];
  }

  // Add a team to selection and update students
  onItemSelect(item: any) {
    this.selectedTeams.push(item);
    this.updateSelectedStudents();
  }

  // Remove a team from selection and update students
  onItemDeSelect(item: any) {
    this.selectedTeams = this.selectedTeams.filter(t => t._id !== item._id);
    this.updateSelectedStudents();
  }

  // Select all teams and update students
  onSelectAll(items: any) {
    this.selectedTeams = [...items];
    this.updateSelectedStudents();
  }

  // Deselect all teams and clear students
  onDeSelectAll(items: any) {
    this.selectedTeams = [];
    this.selectedStudentsArray = [];
        this.updateSelectedStudents();
  }

  // Update selectedStudentsArray based on selectedTeams, removing duplicates
 private updateSelectedStudents() {
  const selectedTeamIds = this.selectedTeams.map(t => t._id);

  let students = this.projectTeams
    .filter(team => selectedTeamIds.includes(team._id))
    .flatMap(team => team.members || []); 

  // remove duplicates safely
  this.selectedStudentsArray = students.filter(
    (student, index, self) =>
      student && index === self.findIndex(s => s._id === student._id)
  );
}



get roles() {
    return localStorage.getItem('role');
  }
  
  openEventModel() {      	
    document.querySelector('body, html').classList.add('hidden');
    this.addEventModel = this.modal.open(this.createNewEvent, { windowClass: 'newEvent', centered: true, size: "sm", backdrop: 'static', keyboard: false });
    this.get_credentials();
    this.onTypeChangeChecks();
  }


  closeModel() {
    this.resetData();
    this.addEventModel.close();
    document.querySelector('body, html').classList.remove('hidden');
    this.resetStep();

  }

  initializeData() {
  	this.createAddEventForm();
  }

  createAddEventForm() {
  	this.addEventForm = this.fb.group({
  	  title: ['', [Validators.required]],
  	  description: ['', [Validators.required]],
  	  date: [null, [Validators.required]],  	  
  	  startTime: [null, [Validators.required]],
  	  endTime: [null, [Validators.required]],
  	  event_type: ['webinar', [Validators.required]],
      led_by: this.fb.group({
        id: [''],
        type: ['', Validators.required],
        name: [[], Validators.required], 
        email: ['']
      }),
      invited_membes: ["", [this.common.multipleEmailValidator]]
  	});
  }


  get ledByGroup(): FormGroup {
  return this.addEventForm.get('led_by') as FormGroup;
}

  onSelectZoom(value){
   this.selectedZoomAccount = value;
  }

  
  //FOR FORM SUBMIT
  onAddEventFormSubmit() {
    this.stepTosubmitEvent = true;

    if (!this.validateForm()) {
      return false;
    }

    if(this.roles === 'teacher' || this.roles === 'mentor' || this.roles === 'org_admin'){
      this.createWebinars();
    }
  }

  // webinar api intgration
  createWebinars(){
    let eventType = this.addEventForm.value.event_type;
    let SpeakerType = this.addEventForm.get('led_by.type').value;
    if (SpeakerType === 'guest_led') {
      const guestName = this.addEventForm.get('led_by.name').value;
      if (guestName) {
        this.addEventForm.get('led_by.name').setValue([guestName]);
      }
    }

    if(this.zoom_accounts.length === 0){
      this.notificationService.showNotification('info', `You haven't added Zoom account details yet. Please click "App" option from profile menu to add Zoom details.`);
      return false;
    }
    //  if (SpeakerType == 'mentor_led'){
    //   if(this.selectedStudentsArray.length === 0 && this.selectedTeams.length === 0){
    //         this.notificationService.showNotification('info', `No member found. Please create a team or add members to an existing team to continue.`);
    //     return false;
    //   }
    // }

    if (SpeakerType == 'mentor_led'){
      if(this.selectedStudentsArray.length === 0 && this.selectedTeams.length === 0){
            this.notificationService.showNotification('info', `No member found. Please create a team or add members to an existing team to continue.`);
        return false;
      }
    }

  
    if(this.passionProjectId === '' || this.passionProjectId === null || this.passionProjectId === undefined){
      return false;
    }

    // get selected zoom account detail
    let getZoomAccount = this.zoom_accounts.filter((zoomAccount:any)=>{
      if(zoomAccount.email === this.selectedZoomAccount){
       return zoomAccount;
      }
     })
 
     let eventDate = this.addEventForm.value.date;
     const date = new Date(eventDate.year, eventDate.month - 1, eventDate.day);
     // Format the date using DatePipe
     this.formattedEventDate = this.datePipe.transform(date, 'yyyy-MM-dd');

    //  get teams unique member and mentor 
    let teamStuentsArray = this.getTeamMembers(this.projectTeams);
    let mentorArray = this.getTeamMentor(this.projectDetails);
    this.mentorListId = [];
    this.memberListId = [];

     if (SpeakerType == 'mentor_led') {
       this.selectedStudentsArray.forEach(student => {
         if (!this.memberListId.includes(student._id)) {
           this.memberListId.push(student._id);
         }
       });       
     } else{
       teamStuentsArray.filter((menber:any)=>{
         if (!this.memberListId.includes(menber._id)) {
           this.memberListId.push(menber._id);
         }
       });
     }

    mentorArray.filter((menber:any)=>{
      if(!this.mentorListId.includes(menber.id))
      this.mentorListId.push(menber.id); 
    });

    this.selectedStuentsArray = [...this.memberListId, ...this.mentorListId];
   if(this.projectTeams.length === 0 ||  this.selectedStuentsArray.length === 0){
            this.notificationService.showNotification('info', `No member found. Please create a team or add members to an existing team to continue.`);
      return false;
    }

    // For invite members
    // prepare optional users as an array field and filter empty emails
    const invitedMembes = this.addEventForm.get('invited_membes').value || '';
    const cleanedEmails = invitedMembes.split(',').map(email => email.trim()).filter(email => email.length > 0);
    const optionalUsers = Array.from(new Set(cleanedEmails));

     // payload Json
     let postData = {
       date: this.formattedEventDate,
       startTime: this.addEventForm.value.startTime,
       endTime: this.addEventForm.value.endTime,
       event_type: this.addEventForm.value.event_type,
       zoom_account: {
                         app_email: getZoomAccount[0].email,
                         account_id:getZoomAccount[0].s2s_account_id,
                         client_id: getZoomAccount[0].s2s_client_id,
                         client_secret_key: getZoomAccount[0].s2s_client_secret_key,
                         is_free: getZoomAccount[0].is_free ? true : false
                       },
       title: this.addEventForm.value.title,
       description: this.addEventForm.value.description,
       register_user: this.selectedStuentsArray,
       passion_project_id:this.passionProjectId,
       project_name:this.projectDetails.project_title,
       led_by:this.addEventForm.value.led_by,
       optional_user_mail: optionalUsers
     }

     if (this.formType == 'add') {    
       if(eventType === 'webinar'){
         this.saveLoader = true;
         this.mentorshiptService.webinarApi(postData)
           .subscribe(response => {
             this.saveLoader = false;
             this.eventSaved(response);
             this.resetStep();
             this.closeModel();
             this.notificationService.showNotification('success', response.message);
           },
           (err) => {
             this.saveLoader = false;
             this.notificationService.showNotification('error', err.message);
           })
       }
      } else  if (this.formType == 'edit') {    
       if(eventType === 'webinar'){
        postData['webinar_id'] = this.selectedEvent.webinar_id;
         this.saveLoader = true;
         this.mentorshiptService.webinarApiPatch(postData)
           .subscribe(response => {
             this.saveLoader = false;
             this.eventSaved(response);
             this.resetStep();
             this.closeModel();
             this.notificationService.showNotification('success', response.message);
           },
           (err) => {
             this.saveLoader = false;
             this.notificationService.showNotification('error', err.message);
           })
       }
      }
  }

  // to get unique member from team
  getTeamMembers(projectTeam:any){
    const memberMap = new Map<string, any>();
    projectTeam.forEach(team => {
      team.members.forEach(member => {
        memberMap.set(member._id, member);
      });
    });
    return Array.from(memberMap.values())
  }


  // to get unique mentors
    getTeamMentor(projectMentor:any){
     const mentorMap = new Map<string, any>();
        projectMentor.project_mentors.forEach(mentor => {
          mentorMap.set(mentor.id, mentor);
        });
    return Array.from(mentorMap.values())
  }

  eventSaved(response: any) {
  	this.eventStatus.emit({status: true});
  	this.addEventModel.close();
  	this.resetData();
  }

  validateForm() {    
    if (this.addEventForm.invalid) {
      this.notificationService.showNotification("error", "Please correct the form like Event Name, Event Note, Event Date, and other need to be correct.");
      return false;
    }

    if(!this.validateEventTime()) {
      return false;
    }

    return true;
  }

  validateEventTime() {
    const eventDate = this.addEventForm.value.date;
    const eventStartTime = this.addEventForm.value.startTime;
    const eventEndTime = this.addEventForm.value.endTime;
    const startDateTime = new Date(eventDate.year+'/'+eventDate.month+'/'+eventDate.day+' '+eventStartTime+':00');
    const endDateTime = new Date(eventDate.year+'/'+eventDate.month+'/'+eventDate.day+' '+eventEndTime+':00');
    const startTimeStamp = startDateTime.getTime();
    const endTimeStamp = endDateTime.getTime();
    let todayDate = this.getTodayDate();
    const todayTimeStamp = todayDate.getTime();

    let checkDateTime = true;
    if(this.formType == 'edit') {
      const rawDate = this.selectedEvent.start; 
      const dateOnly  = new Date(rawDate);;

      const selDate = dateOnly;

          // event time start/end formated
    const dateEventStart = new Date(this.selectedEvent.start);
    const dateEventEnd = new Date(this.selectedEvent.end);
    const selStartTime = this.datePipe.transform(dateEventStart, 'HH:mm');
    const selEndTime = this.datePipe.transform(dateEventEnd, 'HH:mm');


      // const selStartTime = this.selectedEvent.startTime;
      // const selEndTime = this.selectedEvent.endTime;

      if(selDate.getFullYear() == eventDate.year && selDate.getMonth() + 1 == eventDate.month && selDate.getDate() == eventDate.day && selStartTime == eventStartTime && selEndTime == eventEndTime) {
        checkDateTime = false;
      }
    }

    if(checkDateTime == true) {
      if(startTimeStamp < todayTimeStamp) {
        this.notificationService.showNotification("error", "Event date and time should be greater than or equal to current date and time.");
        return false;
      }
      if(startTimeStamp >= endTimeStamp) {
        this.notificationService.showNotification("error", "Event end time should be greater than event start time.");
        return false;
      }
    }

    return true;
  }

  getTodayDate() {
    let todayDate = new Date();
    todayDate.setSeconds(0);
    todayDate.setMilliseconds(0);
    return todayDate;
  }

  getPostData() {
    let postData = this.addEventForm.value;

    return postData;
  }

  // reset form data
  resetData() {
  	this.initializeData();
    this.stepTosubmitEvent = false;
    this.formType = 'add';
    this.selectedEvent = null;
  }

  //FOR EDIT FORM
  setEditEventData() {
   // event date formated
    const rawDate = this.selectedEvent.start; 
    const dateOnly  = rawDate.split(' ')[0];

    const [year, month, day] = dateOnly.split('-').map(Number);
    const ngbDate: NgbDateStruct = { year, month, day };

    // event time start/end formated
    const dateEventStart = new Date(this.selectedEvent.start);
    const dateEventEnd = new Date(this.selectedEvent.end);
    this.formattedDateStart = this.datePipe.transform(dateEventStart, 'HH:mm');
    this.formattedDateEnd = this.datePipe.transform(dateEventEnd, 'HH:mm');

    this.addEventForm.get('title').setValue(this.selectedEvent.title);
    this.addEventForm.get('description').setValue(this.selectedEvent.description);
    this.addEventForm.get('date').setValue(ngbDate);
    this.addEventForm.get('startTime').setValue(this.formattedDateStart);
    this.addEventForm.get('endTime').setValue(this.formattedDateEnd);
    this.addEventForm.get('event_type').setValue('webinar');
    this.addEventForm.get('led_by.id').setValue(this.selectedEvent.led_by.id);
    this.addEventForm.get('led_by.type').setValue(this.selectedEvent.led_by.type);

    if(this.selectedEvent.led_by.type === 'guest_led'){
      if (this.selectedEvent.led_by.name.length === 1) {
        this.addEventForm.get('led_by.name').setValue(this.selectedEvent.led_by.name[0]); 
      } 
    }  else{
      this.addEventForm.get('led_by.name').setValue(this.selectedEvent.led_by.name);
    }
    this.addEventForm.get('led_by.email').setValue(this.selectedEvent.led_by.email);

    // For invite members
    if(this.selectedEvent.optional_user_mail && this.selectedEvent.optional_user_mail.length) {
      this.addEventForm.get('invited_membes').setValue(this.selectedEvent.optional_user_mail.join(', '));
    }
  }


  // get zoom credentials
  get_credentials() {
    if((this.roles !== 'teacher') && (this.roles !== 'mentor')  && (this.roles !== 'org_admin')){
      return;
    }
    this.user_service.get_zoom_account().subscribe(zoom_account => {      
      this.get_zoom_account = zoom_account.response
      this.zoom_accounts = zoom_account.response.apps.zoom_s2s;

      this.zoom_accounts.filter((zoomAccount)=>{
        if(zoomAccount.is_default === true){
          this.selectedZoomAccount = zoomAccount.email;
        }
      })
    },
      (err) => {
        this.notificationService.showNotification('error', err.message);
      });
  }


  // reset model
  resetStep(){
    this.createEventStep1 = true;
    this.createEventStep2 = false;
    this.orgCourseList = [];
    this.selectedCouseId = '';
    this.orgCourseList = [];
    this.selectStudentListOriginal = [];
    this.selectStudentList = [];
    this.searchStudentsQuery = ''; 
    this.selectedStudentList = [];
    this.selectedLevelType = 'no_value';
    this.isCheckedAll = false;
    this.onTypeChangeChecks();
  }
  ngOnDestroy() {
    this.eventActionSub.unsubscribe();
 if (this.typeChangeSubscription) {
        this.typeChangeSubscription.unsubscribe();
      }
  }

}
